module.exports = __webpack_public_path__ + "media/src/images/abouts/items/delivery/640x640_Brown-d601fda5786f1ce49de7e09b20b22a2b.jpg";